module.exports = __webpack_public_path__ + "static/media/view student wise.5f16dfd3.svg";